const noRoleRoutes = [
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: "person",
    route: "/profile",
  },
];

export default noRoleRoutes;